import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Organizations } from './pages/Organizations';
import { Sites } from './pages/Sites';
import { UnitData } from './pages/UnitData';
import { Settings } from './pages/Settings';
import { AcceptInvite } from './pages/AcceptInvite';
import { ProvisionWizard } from './pages/ProvisionWizard';
import { ProvisionGenerate } from './pages/ProvisionGenerate';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { DeviceLanding } from './pages/DeviceLanding';
import { Devices } from './pages/Devices';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Landing />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/invite/:token',
    element: <AcceptInvite />,
  },
  {
    path: '/provision/:provisioningId',
    element: <ProvisionWizard />,
  },
  {
    path: '/d/:serial',
    element: <DeviceLanding />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms',
    element: <TermsOfService />,
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <DashboardLayout />,
        children: [
      { index: true, element: <Dashboard /> },
      { path: 'organizations', element: <Organizations /> },
      { path: 'sites', element: <Sites /> },
      { path: 'provision', element: <ProvisionGenerate /> },
      { path: 'provision/devices', element: <Devices /> },
      { path: 'units/:unitId', element: <UnitData /> },
      { path: 'settings', element: <Settings /> },
        ],
      },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
